import React, { useCallback, useEffect, useState } from 'react';
import { Card, Button, Empty, Tag, Spin, message, Alert } from 'antd';
import { CompassOutlined, EnvironmentOutlined, DollarOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

// Feed "Jogos perto de voce" — top 5 jogos abertos de times publicos
// dentro do search_radius_km do jogador. Botao candidata direto ao jogo.
const NearbyGamesCard = () => {
  const nav = useNavigate();
  const [loading, setLoading] = useState(true);
  const [games, setGames] = useState([]);
  const [reason, setReason] = useState(null);
  const [applying, setApplying] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get('/community/players/nearby-games');
      setGames(r.data.games || []);
      setReason(r.data.reason || null);
    } catch {
      setGames([]);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const apply = async (g) => {
    setApplying(g.id);
    try {
      await api.post('/community/invites/apply-to-team', {
        team_id: g.team_id, message: `Quero jogar no ${g.team_name}`,
        game_id: g.id, kind: 'GAME',
      });
      message.success('Bora! Candidatura mandada.');
      load();
    } catch (e) {
      message.error(e?.response?.data?.message || 'Erro ao candidatar');
    } finally { setApplying(null); }
  };

  if (loading) {
    return (
      <Card size="small" title={<><CompassOutlined /> Jogos perto de você</>} style={{ marginBottom: 16 }}>
        <div style={{ textAlign: 'center', padding: 20 }}><Spin /></div>
      </Card>
    );
  }

  if (reason === 'sem_localizacao') {
    return (
      <Card size="small" title={<><CompassOutlined /> Jogos perto de ti</>} style={{ marginBottom: 16 }}>
        <Alert
          type="info" showIcon
          message="Falta teu CEP pra mostrar quem tá jogando por perto"
          description="Só um minuto — vai lá em Meu Perfil."
          action={<Button type="primary" size="small" onClick={() => nav('/player/profile')}>Colocar meu CEP</Button>}
        />
      </Card>
    );
  }

  if (games.length === 0) {
    return (
      <Card size="small" title={<><CompassOutlined /> Jogos perto de ti</>} style={{ marginBottom: 16 }}>
        <Empty description="Ninguém escalou pelada essa semana por aqui. Volta amanhã que a gente atualiza direto." />
      </Card>
    );
  }

  return (
    <Card size="small" title={<><CompassOutlined /> Jogos perto de ti</>}
      extra={<Button type="link" size="small" onClick={() => nav('/player/map')}>Ver no mapa</Button>}
      style={{ marginBottom: 16 }}
    >
      <div style={{ display: 'flex', gap: 12, overflowX: 'auto', paddingBottom: 4 }}>
        {games.map(g => {
          const pending = g.last_application_status === 'PENDING';
          const done = g.last_application_status === 'ACCEPTED';
          return (
            <div key={g.id} style={{
              minWidth: 240, maxWidth: 280, background: '#fff', border: '1px solid #eef1f4',
              borderRadius: 12, padding: 12,
            }}>
              <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>{g.team_name}</div>
              <div style={{ fontSize: 12, color: '#666', display: 'flex', alignItems: 'center', gap: 4 }}>
                <EnvironmentOutlined /> {g.neighborhood || g.court_name || g.city}
                {g.distance_km != null && <Tag color="blue" style={{ marginLeft: 4 }}>{g.distance_km.toFixed(1)} km</Tag>}
              </div>
              <div style={{ fontSize: 13, marginTop: 8, color: '#333' }}>
                ⚽ <b>{g.date_of_game}</b>
              </div>
              {g.guest_price && (
                <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                  <DollarOutlined /> R$ {g.guest_price} (avulso)
                </div>
              )}
              <div style={{ marginTop: 10 }}>
                {done ? (
                  <Tag color="green">Já é seu time</Tag>
                ) : pending ? (
                  <Tag color="orange">Pendente</Tag>
                ) : (
                  <Button
                    type="primary" size="small" block
                    loading={applying === g.id}
                    onClick={() => apply(g)}
                  >Bora!</Button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default NearbyGamesCard;
